var map = {
	"./activities.svg": [
		80106,
		80106
	],
	"./bed.svg": [
		39946,
		39946
	],
	"./billiards.svg": [
		77117,
		77117
	],
	"./brasero.svg": [
		26535,
		26535
	],
	"./breakfast.svg": [
		80,
		80
	],
	"./concierge.svg": [
		68002,
		68002
	],
	"./dimension.svg": [
		34875,
		34875
	],
	"./luxe.svg": [
		9001,
		9001
	],
	"./multisport.svg": [
		77222,
		77222
	],
	"./parking.svg": [
		71503,
		71503
	],
	"./people.svg": [
		79628,
		79628
	],
	"./pool.svg": [
		57335,
		57335
	],
	"./pools.svg": [
		27334,
		27334
	],
	"./premium.svg": [
		65312,
		65312
	],
	"./sauna.svg": [
		95161,
		95161
	],
	"./shower.svg": [
		93303,
		93303
	],
	"./sport.svg": [
		74709,
		74709
	],
	"./suits.svg": [
		22781,
		22781
	],
	"./tree.svg": [
		1785,
		1785
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 11725;
module.exports = webpackAsyncContext;